import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { endpoints } from 'src/environments/endpoints';
import { CriarMovimentacaoCadastralPayload } from '../../models/movimentacao-cadastral/CriarMovimentacaoCadastralPayload';
import { CriarMovimentacaoCadastralResponse } from '../../models/movimentacao-cadastral/CriarMovimentacaoCadastralResponse';
import { DetalheImportacaoMovimentacaoCadastral } from '../../models/movimentacao-cadastral/DetalheImportacaoMovimentacaoCadastral';
import { MovimentacaoCadastral } from '../../models/movimentacao-cadastral/MovimentacaoCadastral';
import { ExportacaoArquivoProvedor } from '../../models/beneficiario/ExportacaoArquivoProvedor';

@Injectable({
  providedIn: 'root',
})
export class MovimentacaoCadastralService {
  http = inject(HttpClient);

  private baseUrl = endpoints.movimentacaoCadastral;

  getMovimentacoesCadastrais(): Observable<MovimentacaoCadastral[]> {
    const url = `${this.baseUrl}/listar`;

    return this.http.get<MovimentacaoCadastral[]>(url);
  }

  criarMovimentacaoCadastral(
    payload: CriarMovimentacaoCadastralPayload
  ): Observable<CriarMovimentacaoCadastralResponse> {
    const formData = new FormData();

    formData.append('tipoMovimentacao', String(payload.tipoMovimentacao));
    formData.append('Documento', payload.documento);

    return this.http.post<CriarMovimentacaoCadastralResponse>(
      this.baseUrl,
      formData
    );
  }

  getDetalhesImportacao(
    guidImportacao: string
  ): Observable<DetalheImportacaoMovimentacaoCadastral[]> {
    const url = `${this.baseUrl}/${guidImportacao}`;

    return this.http.get<DetalheImportacaoMovimentacaoCadastral[]>(url);
  }

  getDocumentoCriticas(guidImportacao: string): Observable<ArrayBuffer> {
    const url = `${this.baseUrl}/gerarDocumentoCriticas/${guidImportacao}`;

    return this.http.post(url, {}, { responseType: 'arraybuffer' });
  }

  getExportacoesLayoutProvedor(): Observable<ExportacaoArquivoProvedor[]> {
    const url = endpoints.exportacaoLayoutProvedor;

    return this.http.get<ExportacaoArquivoProvedor[]>(url);
  }
}
